import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';
const UPLOADS_BASE = API_BASE.replace('/api', '');

// Motor silhouette sekarang diambil dinamis dari /api/motor-types (bisa di-CRUD admin)

// Placeholder gear person — data URI, ganti ke UPLOADS_BASE/uploads/gear-person.png kalau asset asli sudah diupload
const GEAR_PLACEHOLDER = "data:image/svg+xml;utf8," + encodeURIComponent(`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400">
    <circle cx="100" cy="50" r="35" fill="#2A2A2E"/>
    <rect x="70" y="90" width="60" height="120" rx="16" fill="#2A2A2E"/>
    <rect x="55" y="100" width="20" height="90" rx="10" fill="#2A2A2E"/>
    <rect x="125" y="100" width="20" height="90" rx="10" fill="#2A2A2E"/>
    <rect x="75" y="210" width="22" height="150" rx="10" fill="#2A2A2E"/>
    <rect x="103" y="210" width="22" height="150" rx="10" fill="#2A2A2E"/>
  </svg>
`);

const SOCIAL_PLATFORMS = [
  { key: 'instagram', icon: 'fa-brands fa-instagram', color: '#E4405F', label: 'Instagram' },
  { key: 'tiktok', icon: 'fa-brands fa-tiktok', color: '#F0EDE4', label: 'TikTok' },
  { key: 'youtube', icon: 'fa-brands fa-youtube', color: '#FF0000', label: 'YouTube' },
  { key: 'facebook', icon: 'fa-brands fa-facebook', color: '#1877F2', label: 'Facebook' },
  { key: 'whatsapp', icon: 'fa-brands fa-whatsapp', color: '#25D366', label: 'WhatsApp' },
];

// Render titik hotspot generic dari array {label, x_percent, y_percent, description}
function HotspotDisplay({ specs, silhouetteUrl, altText }) {
  const [active, setActive] = useState(null);
  if (!silhouetteUrl) return null;

  return (
    <div style={{ position: 'relative', width: '100%', maxWidth: 600, background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 20 }}>
      <div style={{ position: 'relative', width: '100%' }}>
        <img src={silhouetteUrl} alt={altText} style={{ width: '100%', height: 'auto', display: 'block' }} />
        {(specs || []).map((h, idx) => (
          <div
            key={idx}
            onClick={() => setActive(active === idx ? null : idx)}
            style={{
              position: 'absolute', left: `${h.x_percent}%`, top: `${h.y_percent}%`, transform: 'translate(-50%, -50%)',
              width: 20, height: 20, borderRadius: '50%',
              background: '#D02127', border: '2px solid #F0EDE4', cursor: 'pointer',
              boxShadow: active === idx ? '0 0 0 6px rgba(208,33,39,0.3)' : 'none',
            }}
          />
        ))}
      </div>
      {active !== null && specs[active] && (
        <div style={{ marginTop: 16, background: '#12151A', border: '1px solid #262b33', borderRadius: 6, padding: 14, display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          {specs[active].photo_url && (
            <div style={{ width: 60, height: 60, borderRadius: 6, overflow: 'hidden', flexShrink: 0, background: '#1C2128' }}>
              <img src={specs[active].photo_url} alt={specs[active].label} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            </div>
          )}
          <div>
            <p style={{ color: '#D02127', fontWeight: 700, fontSize: 13 }}>{specs[active].label}</p>
            <p style={{ color: '#8B92A0', fontSize: 13, marginTop: 4 }}>{specs[active].description || 'Belum diisi'}</p>
          </div>
        </div>
      )}
      {(!specs || specs.length === 0) && (
        <p style={{ color: '#5a616e', fontSize: 12, marginTop: 12 }}>Belum ada titik hotspot yang diatur.</p>
      )}
      {specs && specs.length > 0 && (
        <p style={{ color: '#5a616e', fontSize: 11, marginTop: 12 }}>Tap titik di gambar buat lihat detail.</p>
      )}
    </div>
  );
}

export default function MemberDetail() {
  const { slug } = useParams();
  const [member, setMember] = useState(null);
  const [badges, setBadges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [activeStatus, setActiveStatus] = useState(null);
  const [motorTypes, setMotorTypes] = useState([]);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API_BASE}/member-auth/public/${slug}`)
      .then((res) => {
        if (!mounted) return;
        setMember(res.data);
        axios.get(`${API_BASE}/touring-events/member/${res.data.id}/active-status`)
          .then((r) => { if (mounted) setActiveStatus(r.data); })
          .catch(() => {});
        return axios.get(`${API_BASE}/member-auth/badges/${res.data.id}`);
      })
      .then((res) => {
        if (!mounted || !res) return;
        setBadges(res.data);
      })
      .catch(() => {
        if (mounted) setNotFound(true);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => { mounted = false; };
  }, [slug]);

  useEffect(() => {
    axios.get(`${API_BASE}/motor-types/`)
      .then((res) => setMotorTypes(res.data))
      .catch((err) => console.error('Fetch motor types error:', err));
  }, []);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#12151A', color: '#8B92A0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        Memuat...
      </div>
    );
  }

  if (notFound || !member) {
    return (
      <div style={{ minHeight: '100vh', background: '#12151A', color: '#F0EDE4', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12 }}>
        <p>Member tidak ditemukan.</p>
        <Link to="/" style={{ color: '#2B6996' }}>← Kembali ke Beranda</Link>
      </div>
    );
  }

  // motor_specs & gear_specs sekarang array [{label, x_percent, y_percent, description}], bukan object fixed-key lagi
  const motorSpecs = Array.isArray(member.motor_specs) ? member.motor_specs : [];
  const gearSpecs = Array.isArray(member.gear_specs) ? member.gear_specs : [];
  const motorSilhouette = motorTypes.find(t => t.id === member.motor_type_id);
  const motorSilhouetteUrl = motorSilhouette ? motorSilhouette.image_url : null;

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw' }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
      </nav>
      <div style={{ padding: '0 6vw 60px', maxWidth: 900, margin: '0 auto' }}>
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>

        <div style={{ display: 'flex', gap: 24, alignItems: 'center', margin: '24px 0 40px', flexWrap: 'wrap' }}>
          <div style={{ width: 100, height: 100, borderRadius: '50%', background: '#1C2128', overflow: 'hidden', flexShrink: 0, border: '3px solid #D02127' }}>
            {member.photo_url && (
              <img src={member.photo_url} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
            )}
          </div>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
              <p style={{ color: '#D02127', fontWeight: 800, fontSize: 12, letterSpacing: 2, textTransform: 'uppercase', margin: 0 }}>{member.position}</p>
              {activeStatus?.isActive && (
                <span style={{ background: 'rgba(208,33,39,0.2)', color: '#D02127', fontSize: 10, fontWeight: 800, padding: '2px 8px', borderRadius: 4 }}>
                  🔴 LAGI TOURING
                </span>
              )}
            </div>
            <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic' }}>{member.name}</h1>
            {member.quote && <p style={{ color: '#F0EDE4', fontSize: 15, fontStyle: 'italic', marginTop: 8, maxWidth: 500 }}>"{member.quote}"</p>}
            {member.bio && <p style={{ color: '#8B92A0', fontSize: 14, marginTop: 6, maxWidth: 500 }}>{member.bio}</p>}
            {member.social_links && Object.values(member.social_links).some(v => v) && (
              <div style={{ display: 'flex', gap: 14, marginTop: 10 }}>
                {SOCIAL_PLATFORMS.filter(p => member.social_links[p.key]).map((p) => (
                  <a
                    key={p.key}
                    href={member.social_links[p.key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={p.label}
                    style={{ color: p.color, fontSize: 22 }}
                  >
                    <i className={p.icon}></i>
                  </a>
                ))}
              </div>
            )}
          </div>
        </div>

        {motorSilhouetteUrl && (
          <div style={{ marginBottom: 48 }}>
            <h2 style={{ fontSize: 18, fontWeight: 800, fontStyle: 'italic', marginBottom: 16 }}>Spek Motor</h2>
            <HotspotDisplay specs={motorSpecs} silhouetteUrl={motorSilhouetteUrl} altText={motorSilhouette?.name} />
          </div>
        )}

        <div style={{ marginBottom: 48 }}>
          <h2 style={{ fontSize: 18, fontWeight: 800, fontStyle: 'italic', marginBottom: 16 }}>Gear</h2>
          <HotspotDisplay specs={gearSpecs} silhouetteUrl={GEAR_PLACEHOLDER} altText="Gear" />
        </div>

        <div>
          <h2 style={{ fontSize: 18, fontWeight: 800, fontStyle: 'italic', marginBottom: 16 }}>Riwayat Touring 🏅</h2>
          {badges.length === 0 ? (
            <p style={{ color: '#8B92A0', fontSize: 13 }}>Belum ada riwayat touring.</p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {badges.map((b) => (
                <div key={b.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 14, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                  <div>
                    <p style={{ fontWeight: 700, fontSize: 14 }}>{b.event_title}</p>
                    <p style={{ color: '#8B92A0', fontSize: 12, marginTop: 2 }}>{new Date(b.tanggal_mulai).toLocaleDateString('id-ID')}</p>
                  </div>
                  <div style={{ textAlign: 'right', fontSize: 12, color: '#2B6996' }}>
                    <p>{b.jarak_km} km</p>
                    <p style={{ color: '#8B92A0' }}>{b.jumlah_checkpoint} checkpoint</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
